const ui: any = {
  INACTIVITY_TIMEOUT: 'ui:inactivityTimeout',
  RA_HIDE_MIN_LIMITS: 'scheduling:resourceAvailability:hideMinLimits',
};

export default ui;